<template>
    <div class="field">
        <div class="control has-icons-left">
            <input v-model="displacement"
                   v-bind:class="{ 'is-danger': error && error.length > 0 }"
                   class="input"
                   type="number"
                   placeholder="Type Displacement">
            <span class="icon is-small is-left">
                <i class="fas fa-cogs"></i>
            </span>
            <p v-if="error && error.length > 0" class="help is-danger">{{ error[0] }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            displacement: {
                get: function () {
                    return this.$store.getters.getNewCarDisplacement
                },
                set: function (value) {
                    this.$store.dispatch('setNewCarDisplacement', value)
                }
            },
            error: {
                get: function () {
                    return this.$store.getters.getNewCarErrorDisplacement
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Create/Inputs/DisplacementInput.vue